var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.item.class,on:{"click":function($event){return _vm.item.event(_vm.item.params)}}},[_vm._v("\n  "+_vm._s(_vm.item.values)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }